<template>
  <div>
    <form id="smmr-form" @submit.prevent="update">
      <div class="p-8 flex flex-wrap text-left" @change="dirtyForm()" @keydown="dirtyForm">
        <div class="mb-4">
          Please make your selection of programme and mode of study from the drop-down menus below. You can make a
          maximum of two programme choices.
          Your choices will be considered in sequence starting with your first choice. If you are offered a place on
          your first choice programme you
          will not be considered for any of your subsequent programme choices, unless you withdraw your first choice
          application.
        </div>

        <label class="font-bold mb-2 w-full">
          Please select the type of programme from the drop-down menu below:
        </label>

        <select-input id="programmeTypeSelect" v-model="programmeType" class="pr-6" @change="changeType($event)" disabled>
          <option v-for="programmeType in programmeTypesList.data" :key="programmeType"
                  :value="programmeType.sits_code">
            {{ programmeType.name }}
          </option>
        </select-input>

        <div v-if="chosenProgrammeType" class="w-full">
          <div class="w-full mb-4">
            Please select the programme(s) you are applying for from the drop-down menus below.
          </div>
          <div class="relative w-full px-4 py-4 mb-4 border border-gray-300 bg-gray-100">
            <h2 class="text-green-600 text-2xl leading-10 pr-8 mb-2">Programme choice</h2>
            <div class="flex flex-wrap">
              <div class="w-full md:w-1/4 mr-0 md:pr-4">
                <label>Mode of study:</label>
                <select v-if="chosenProgrammeType" v-model="firstChoiceMode" class="form-select mb-8 w-full bg-white"
                        @change="changeMode($event, 1)">
                  <option v-for="mode in modeOfAttendance" :key="mode" :value="mode['moa_code']">
                    {{ mode['moa_name'] }}
                  </option>
                </select>
              </div>
              <div class="w-full md:w-3/4">
                <label>Programme title:</label>
                <select v-if="chosenProgrammeType" v-model="firstChoice" class="form-select mb-8 w-full bg-white"
                        @change="changeProgramme($event)">
                  <option v-for="programme in programmesList" :key="programme" :value="programme['reference']">
                    {{ programme['programme_title'] }}
                  </option>
                </select>
              </div>

              <div v-if="proposedStartDateShow" class="w-full flex flex-wrap">
                <div class="w-full md:w-1/4 pr-4">
                  <label>* Proposed start date:</label>
                  <select v-if="proposedStartDateShow" v-model="proposedStartDate"
                          class="form-select mb-8 w-full bg-white">
                    <option v-for="startDate in proposedStartDates" :key="startDate.date" :value="startDate.date">
                      {{ startDate.date }}
                    </option>
                  </select>
                </div>

                <div class="w-full md:w-1/4">
                  <text-input v-model="proposedResearchTopic" :width="'full'" label="* Proposed research topic"
                              @update:modelValue="value = $event"/>
                </div>

                <div class="w-full md:w-1/4">
                  <text-input v-model="proposedSupervisor" :width="'full'" class="-mb-5" label="Proposed Supervisor"
                              @update:modelValue="value = $event"/>
                  <label class="text-sm text-black-400">(If you have already contacted an academic member of School staff
                    who has expressed an interest in being your Supervisor, please give their name and Department and/or
                    Faculty, if known.)</label>
                </div>

                <div class="w-full md:w-1/4">
                  <div class=" flex flex-wrap w-full">
                    <label class="mt-8 md:mt-0 w-full mb-2">* Are you an MRC Unit staff member?</label>
                    <div class="w-1/4 mr-3">
                      <input :checked="mrcStaff===1" @input="mrcStaff = $event.target.value" type="radio" value="1"
                             id="1" name="mrcStaff">
                      <label>Yes</label>
                    </div>
                    <div class="w-1/4 ml-3">
                      <input :checked="mrcStaff===0" @input="mrcStaff = $event.target.value" type="radio" value="0"
                             id="0" name="mrcStaff">
                      <label>No</label>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div v-if="showSecondChoice === true"
               class="relative w-full px-4 py-4 mb-4 border border-gray-300 bg-gray-100">
            <h2 class="text-green-600 text-2xl leading-10 pr-8 mb-2">Second choice</h2>
            <div>
              <button type="button"
                      class="absolute top-4 right-4 bg-red-600 hover:bg-red-700 text-white py-1 px-2 rounded text-sm"
                      @click="removeSecondChoice"
              >
                Remove this choice
              </button>
            </div>
            <div v-if="firstChoice !== null && firstChoice === secondChoice">
              <p>Your second programme choice is the same as the first. Please change one of your choices</p>
            </div>
            <div class="flex flex-wrap md:flex-nowrap">
              <div class="w-full md:w-1/4 mr-0 md:mr-2">
                <label>Mode of study:</label>
                <select v-if="chosenProgrammeType" v-model="secondChoiceMode" class="form-select mb-8 w-full bg-white"
                        @change="changeMode($event, 2)">
                  <option v-for="mode in modeOfAttendance" :key="mode" :value="mode['moa_code']">
                    {{ mode['moa_name'] }}
                  </option>
                </select>
              </div>

              <div class="w-full md:w-3/4">
                <label>Programme title:</label>
                <select v-if="chosenProgrammeType" v-model="secondChoice" class="form-select mb-8 w-full bg-white">
                  <option v-for="(programme, index) in programmesList2" :key="programme+index"
                          :value="programme['reference']">
                    {{ programme['programme_title'] }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="mt-10 lg:flex justify-end w-full">
            <div v-if="choiceLimit > 1" class="w-full lg:w-1/2 pb-2">
              <div v-if="secondChoice === null && showSecondChoice === false">
                <button type="button"
                        class="w-full lg:w-auto text-sm flex justify-center items-center bg-green-600 hover:bg-green-700 text-white lg:mb-8 py-2.5 px-4 rounded text-center"
                        @click="addSecondChoice"
                >
                  <icon name="plus-circle" class="w-6 h-6 mr-2"/>
                  Click to add a second programme choice
                </button>
              </div>
            </div>
            <div class="w-1/2 pb-2 mt-0 lg:-mt-8 w-full lg:w-1/2 text-right">
              <div>
                <application-component-save-button :disabled="formDirty && !choicesMatch && !secondChoiceMade"
                                                   class="relative w-full lg:w-2/3 flex justify-center btn-green ml-auto mt-8 md:inline-block text-center"
                                                   type="submit"
                >
                  Save Programme Details
                  <div v-if="loading" class="lds-ring-container absolute top-2">
                    <div class="lds-ring">
                      <div/>
                      <div/>
                      <div/>
                      <div/>
                    </div>
                  </div>
                </application-component-save-button>
              </div>
            </div>
          </div>
          <div v-if="successMessage" class="success-message w-auto">{{ successMessage }}</div>
          <div v-if="serverError" class="w-auto server-error">{{ serverError }}</div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'
import Icon from '@/shared/Icon'

export default {
  components: {
    TextInput,
    SelectInput,
    ApplicationComponentSaveButton,
    Icon,
  },
  props: {
    programmeData: {
      type: Object,
      default: function () {
        return {
          programmeInstance: null,
        }
      },
    },
    programmeTypesList: Object,
    programmes: Object,
    choice: Number,
    choiceTotal: Number,
    applicationRef: String,
    programmeType: String,
    applicationData: Object,
    modeOfAttendance: Object,
    proposedStartDates: Object,
  },
  data() {
    return {
      myProgrammes: Object,
      programmesList: Object,
      programmesList2: Object,

      formDirty: false,
      loading: false,
      successMessage: '',
      serverError: '',
      chosenProgrammeType: this.programmeType ?? this.applicationData['data']['first_choice_type'],
      firstChoice: this.applicationData['data']['first_choice'],
      secondChoice: this.applicationData['data']['second_choice'],
      firstChoiceMode: this.applicationData['data']['first_choice_mode'],
      secondChoiceMode: this.applicationData['data']['second_choice_mode'],
      proposedStartDate: this.applicationData['data']['proposed_start_date'],
      proposedResearchTopic: this.applicationData['data']['proposed_research_topic'],
      proposedSupervisor: this.applicationData['data']['proposed_supervisor'],
      mrcStaff: this.applicationData['data']['mrc_staff'],
      selectedProgrammes: [],
      programmeNames: [],
      showSecondChoice: false,
      secondChoiceWarning: null,
      choiceLimit: 0,
      proposedStartDateShow: false,
    }
  },
  computed: {
    maxChoices: {
      get: function () {
        return this.choiceLimit
      },
      set: function (newValue) {
        this.choiceLimit = newValue
      },
    },
    choicesMatch() {
      return this.firstChoice === null || this.firstChoice === this.secondChoice
    },
    secondChoiceMade() {
      return this.secondChoice === null && this.showSecondChoice === true
    },
    programmeCount() {
      return this.myProgrammes.length ?? 0
    },
    programmeTypeChoice: {
      get: function () {
        if (this.applicationData['data']['first_choice'] !== '') {
          return this.applicationData['data']['first_choice']
        } else {
          return null
        }
      },
    },

  },
  mounted() {
    this.proposedStartDateShow = this.chosenProgrammeType === 'R'

    this.choiceLimit = 4
    this.myProgrammes = this.programmeData
    for (const i in this.programmes) {
      this.programmeNames[this.programmes[i]['reference']] = this.programmes[i]
    }

    const filters = [
      {type: 'programme_type_sits_code', name: this.chosenProgrammeType},
      {type: 'sits_ipo_moac', name: this.firstChoiceMode},
    ]
    this.programmesList = this.programmes.filter(el => filters.every(filterEl => el[filterEl.type] === filterEl.name))

    const filters2 = [
      {type: 'programme_type_sits_code', name: this.chosenProgrammeType},
      {type: 'sits_ipo_moac', name: this.secondChoiceMode},
    ]
    this.programmesList2 = this.programmes.filter(el => filters2.every(filterEl => el[filterEl.type] === filterEl.name))

    if (this.secondChoice !== null) {
      this.showSecondChoice = true
    }
    this.programmesList.sort((a, b) => (a.programme_title > b.programme_title) ? 1 : ((b.programme_title > a.programme_title) ? -1 : 0))
  },
  methods: {
    addSecondChoice() {
      this.secondChoice = null
      this.showSecondChoice = true
    },
    removeSecondChoice() {
      this.showSecondChoice = false
      this.secondChoice = null
      this.secondChoiceMode = null
      this.myProgrammes = new Array(1)
      this.formDirty = true
    },
    changeProgramme(event) {
      this.$emit('programmeChange', event.target.value)
    },
    changeMode(event, choice) {
      const filters = [
        {type: 'programme_type_sits_code', name: this.chosenProgrammeType},
        {type: 'sits_ipo_moac', name: event.target.value},
      ]
      if (choice === 1) {
        this.programmesList = this.programmes.filter(el => filters.every(filterEl => el[filterEl.type] === filterEl.name))
        this.programmesList.sort((a, b) => (a.programme_title > b.programme_title) ? 1 : ((b.programme_title > a.programme_title) ? -1 : 0))
      } else {
        this.programmesList2 = this.programmes.filter(el => filters.every(filterEl => el[filterEl.type] === filterEl.name))
        this.programmesList2.sort((a, b) => (a.programme_title > b.programme_title) ? 1 : ((b.programme_title > a.programme_title) ? -1 : 0))
      }
    },
    changeType(event) {
      const programmeType = this.programmeTypesList.data.filter(type => type['sits_code'] === event.target.value)[0]
      if (programmeType.sits_code === 'R') {
        this.proposedStartDateShow = true
      } else {
        this.proposedStartDateShow = false
        this.proposedStartDate = null
        this.proposedResearchTopic = null
        this.proposedSupervisor = null
        this.mrcStaff = null
      }

      this.choiceLimit = programmeType.max_choices ?? 1

      this.firstChoice = null
      this.removeSecondChoice()

      const filters = [
        {type: 'programme_type_sits_code', name: programmeType.sits_code},
        {type: 'sits_ipo_moac', name: this.firstChoiceMode},
      ]
      this.programmesList = this.programmes.filter(el => filters.every(filterEl => {
        return el[filterEl.type] === filterEl.name;
      }))
      this.chosenProgrammeType = programmeType.sits_code
      this.$emit('typeChanged', programmeType.sits_code)
    },
    update() {
      this.myProgrammes[0] = this.firstChoice
      if (this.secondChoice !== null) {
        this.myProgrammes[1] = this.secondChoice
      }
      this.loading = true
      this.$store.dispatch('updateProgrammeDetails', {
        selectedProgrammes: this.myProgrammes,
        proposedStartDate: this.proposedStartDate,
        proposedResearchTopic: this.proposedResearchTopic,
        proposedSupervisor: this.proposedSupervisor,
        mrcStaff: this.mrcStaff,
        applicationRef: this.applicationRef,
      })
          .then(response => {
            this.loading = false
            this.serverError = ''
            this.successMessage = response.data

          })
          .catch(error => {
            this.loading = false
            this.serverError = error.response.data
            this.successMessage = ''
          })
      this.formDirty = false
    },
    dirtyForm() {
      this.formDirty = true
      this.successMessage = ''
    },
  },
}
</script>